<template>
  <div
    :data-test-id="testId"
    class="tw-z-[55] tw-rounded-md tw-border-2 tw-p-3"
    role="alert"
    :class="{
      'tw-border-success-500 tw-bg-success-50': props.variant === 'success',
      'tw-border-danger-500 tw-bg-danger-50': props.variant === 'danger',
      'tw-border-info-500 tw-bg-info-50': props.variant === 'info',
    }"
  >
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-2">
      <div
        class="tw-p-1 tw-rounded-full"
        :class="{
          'tw-bg-success-100 tw-bg-success-500': props.variant === 'success',
          'tw-bg-danger-100 tw-bg-danger-500': props.variant === 'danger',
          'tw-bg-info-100 tw-text-info-500': props.variant === 'info',
        }"
      >
        <ClIconTablerCircleCheck
          v-if="props.variant === 'success'"
          class="tw-text-success-500"
        />
        <ClIconTablerExclamationCircle
          v-else-if="props.variant === 'danger'"
          class="tw-text-danger-500"
        />
        <ClIconTablerInfoCircle
          v-else-if="props.variant === 'info'"
          class="tw-text-info-500"
        />
      </div>
      <div
        class="tw-flex-grow tw-overflow-hidden tw-whitespace-normal tw-break-words"
      >
        <div
          v-if="$slots.title"
          class="tw-text-lg tw-font-semibold"
          :data-test-id="`${testId}-title`"
        >
          <slot name="title" />
        </div>
        <div
          v-else-if="$slots.message"
          class="tw-text-sm"
          :data-test-id="`${testId}-message`"
        >
          <slot name="message" />
        </div>
      </div>
      <button
        v-if="withCloseButton"
        class="tw-inline-flex"
        aria-label="Close"
        :data-test-id="`${testId}-close-button`"
        @click="emitCloseBtnClick(id)"
      >
        <ClIconTablerX />
      </button>
    </div>
    <div
      v-if="$slots.title && $slots.message"
      class="tw-text-sm tw-ml-10"
      :data-test-id="`${testId}-message`"
    >
      <slot name="message" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ClIconTablerInfoCircle,
  ClIconTablerX,
  ClIconTablerCircleCheck,
  ClIconTablerExclamationCircle,
} from "@cl/components/icons";

export interface Props {
  id: string;
  variant?: "success" | "danger" | "info";
  testId?: string;
  withCloseButton?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  variant: "success",
  testId: "cl-callout",
  withCloseButton: false,
});

const emit = defineEmits<{
  (event: "on-close", id: string): void;
}>();

const emitCloseBtnClick = (id: string): void => {
  emit("on-close", id);
};
</script>
